<template>
    <FilterBody
        v-model:search-model-value="companyFilterProperties.searchTerm"
        :label="t('projectclient.projectlist.table.company.header')"
        :display-search="true"
        :search-placeholder="t('projectclient.projectlist.topbar.filters.company.search.placeholder')"
        :items="companyFilterProperties.displayedResults"
        :selected-items="screenSizeSearchParams.companies"
        :pending="companyFilterProperties.pending"
        :display-show-more="companyFilterProperties.hasMoreToShow && !companyFilterProperties.isSearchActive"
        @reset="projectListFiltersStore.handleResetCategory('companies')"
        @check:item="handleCheckBoxChange"
        @show-more="handleShowMore"
    >
        <template #item="{item}">
            {{ `${item.label} ${item.count > 0 ? `(${item.count})` : ''}` }}
        </template>
    </FilterBody>
</template>

<script lang="ts" setup>
    import {computed} from 'vue';
    import type {TypedAggregationResource} from '@common/composables';
    import {useScreenSizeStore} from '@common/stores';
    import {useProjectsListStore, useProjectsListFiltersStore} from '@features/projects-list/stores';
    import {storeToRefs} from 'pinia';
    import {useTranslation} from '#imports';
    import FilterBody from '../wrappers/FilterBody.vue';

    const {t} = useTranslation();

    const screenSizeStore = useScreenSizeStore();
    const {isSmallScreen} = storeToRefs(screenSizeStore);

    const projectListStore = useProjectsListStore();
    const {searchParams} = storeToRefs(projectListStore);

    const projectListFiltersStore = useProjectsListFiltersStore();
    const {temporarySearchParams, companyFilterProperties} = storeToRefs(projectListFiltersStore);

    const screenSizeSearchParams = computed(() => {
        if (isSmallScreen.value) {
            return temporarySearchParams.value;
        } else {
            return searchParams.value;
        }
    });

    function handleCheckBoxChange(item: TypedAggregationResource<string>) {
        projectListFiltersStore.handleUpdateCategory('companies', item.value);
    }

    function handleShowMore() {
        companyFilterProperties.value.resultsSize += 6;
    }
</script>
